import angular from 'angular';
import ngSanitize from 'angular-sanitize';
import '../../assets/styles/base.css';
import '../../assets/styles/modules/hero.css';
import '../../assets/styles/modules/button.css';
import '../../assets/styles/modules/validation.css';
import '../../assets/styles/modules/alert.css';
import '../../assets/styles/modules/forms.css';
import '../../assets/styles/modules/loader.css';
import './watch.layout.css';
import watch from './watch.directive';
import embed from './embed.directive';
import watchService from './watch.service';

import countdown from '../countdown/countdown.directive';
import countdownClock from '../countdownclock/countdownclock.directive';
import uiService from '../userinteraction/userinteraction.service';
import userinteraction from '../userinteraction/userinteraction.directive';
import { combineReducers } from 'redux';
import ngRedux from 'ng-redux';

import chat from '../userinteraction/chat/chat.directive';
import lobbyquestion from '../userinteraction/lobbyquestion/lobbyquestion.directive';
import '../userinteraction/userinteraction.css';
import { thumbnail } from '../thumbnail/thumbnail.component';
import { qnachat } from '../userinteraction/qna/chat/qna.chat.component';
import { qnamessage } from '../userinteraction/qna/chat/message/qna.message.component';
import actions from '../userinteraction/qna/chat/store/actions';
import { messages, ui } from '../userinteraction/qna/chat/store/reducers';

const reduxConfig = [
    '$ngReduxProvider',
    $ngReduxProvider => {
        const rootReducer = combineReducers({
            messages,
            ui
        });
        $ngReduxProvider.createStoreWith(rootReducer, []);
    }
];

export default angular
    .module('watch', [ngRedux, ngSanitize])
    .directive('vlWatch', watch)
    .directive('vlEmbed', embed)
    .directive('vlcountdown', countdown)
    .directive('vlcountdownclock', countdownClock)
    .service('uiService', uiService)
    .service('watchService', watchService)
    .component('vlQnaChat', qnachat)
    .component('vlQnaMessage', qnamessage)
    .component('vlThumb', thumbnail)
    .factory('qnaActions', actions)
    .config(reduxConfig)
    .directive('vlchat', chat)
    .directive('vlquestionnaire', lobbyquestion)
    .directive('vluserinteraction', userinteraction).name;
